module services {
    export module tariff {
        export class tariffCountryGroupOriginService implements interfaces.tariff.ITariffCountryGroupOriginService {
            static $inject = ["$resource", "ENV"];

            constructor(private $resource: ng.resource.IResourceService, private ENV: interfaces.applicationcore.serverConfig) {
            }

            //Gets list of all TariffCountry for a dropdown/autocomplete list
            getDropdownList(): ng.resource.IResourceClass<interfaces.applicationcore.IDropdownModel> {

                return this.$resource<interfaces.applicationcore.IDropdownModel>(this.ENV.DSP_URL + "TariffCountryGroupOrigin/GetDropdownList", {
                    countryGroupId: '@countryGroupId'
                }, {
                        query: {
                            method: 'GET',
                            isArray: true
                        }
                    });
            }
        }
    }
    angular.module("app").service("tariffCountryGroupOriginService", services.tariff.tariffCountryGroupOriginService);
}